import * as env from '@/config.staging.js';
export default { env };